import { sendLogToOpenObserve } from '@/api';
import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import { routes } from '@/constants/routes.const';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { OpenObserveRequest } from '@/types/common.type';
import { AirportSelection } from '@repo/components';
import { generateUUIDv7, isRefundableAirport } from '@repo/utils';
import { Button } from '@successmode-ktp/kui';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const SelectAirport = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    nationality,
    passportNumber,
    departureDate,
    isCashPickup,
    isUploadRequired,
  } = useAppSelector((state) => state as IGlobalState);
  const [selectedAirport, setSelectedAirport] = useState('');

  const onNextPage = () => {
    passportNumber && localStorage.setItem(passportNumber, selectedAirport);

    // @ts-ignore
    if (import.meta.env.MODE !== 'development') {
      onAddLog();
    }

    const isTransferWeb = localStorage.getItem(`${passportNumber}-transfer`);
    if (isTransferWeb === 'true') {
      if (departureDate) {
        history.push({
          pathname: routes.home,
        });
      } else {
        history.push({
          pathname: routes.departure,
        });
      }
      return;
    }

    if (isRefundableAirport(selectedAirport)) {
      const isReadAirportGuide =
        localStorage.getItem('isReadAirportGuide') === 'yes';
      history.push(isReadAirportGuide ? routes.airport : routes.airportGuide);
    } else {
      if (isCashPickup) {
        if (departureDate) {
          history.push({
            pathname: routes.cashPickupIntro,
          });
        } else {
          history.push({
            pathname: routes.departure,
          });
        }
        return;
      }
      if (isUploadRequired) {
        if (departureDate) {
          history.push({
            pathname: routes.refundProcedure,
          });
        } else {
          history.push({
            pathname: routes.departure,
          });
        }
        return;
      }
      history.push(`${routes.airportNonRefundable}`);
    }
  };

  console.log('departureDate', departureDate);

  const { mutate: mutateSendLogToOpenObserve } = useMutation({
    mutationFn: (payload: OpenObserveRequest) => sendLogToOpenObserve(payload),
  });

  const onAddLog = () => {
    const body = `여권번호=${passportNumber}, 국적=${nationality}, 공항=${selectedAirport}`;

    mutateSendLogToOpenObserve({
      body,
      category: 'airport-selection',
      trace_id: generateUUIDv7(),
      dataForLog: {
        passportNumber: passportNumber || '',
        airport: selectedAirport || '',
        type: 'STORE',
      },
    });

    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: {
        needToLogAirport: false,
      },
    });
  };

  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    next: ['Next', '다음으로'],
  };

  return (
    <ReceiptLayout>
      <Content>
        <AirportSelection
          selectedAirport={selectedAirport}
          onSelect={setSelectedAirport}
          nationality={nationality}
        />
      </Content>
      <Button
        onClick={onNextPage}
        disabled={selectedAirport === ''}
        style={
          selectedAirport === ''
            ? {
                backgroundColor: '#d3e2fd',
                marginBottom: '36px',
              }
            : undefined
        }
        size='lg'
      >
        {text.next[nationIndex]}
      </Button>
    </ReceiptLayout>
  );
};

const Content = styled.div`
  width: 100%;
`;

export default SelectAirport;
